import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'boolean'
  })
  export class BooleanPipe implements PipeTransform {
    transform(value: any): any {
        if (value == 'true' || value === true) {
            return 'Yes';
        } else if (value == 'false' || value === false) {
            return 'No';
        } else if (typeof(value) == 'string'){
            // convert formatting in case of camelCase
            const camelToFlat = c => (c = c.replace(/[A-Z]/g, " $&"), c[0]?.toUpperCase() + c.slice(1))
            const newValue = camelToFlat(value);
            return newValue;
        } else {
            return value;
        }
    }
  }